export default __webpack_public_path__ + "static/media/IMG_4740.35bab0fa.JPG";